import { render, staticRenderFns } from "./schoolCateredPriceList.vue?vue&type=template&id=4527f0d2&scoped=true&"
import script from "./schoolCateredPriceList.vue?vue&type=script&lang=js&"
export * from "./schoolCateredPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4527f0d2",
  null
  
)

export default component.exports